<div cdkDropListGroup class="mat-typography flex-row gap-16">
  <div id="selected-columns" class="flex-50">
    <div class="caption">Selected Columns</div>
    <div cdkDropList [cdkDropListData]="selectedColumns" class="list-container" (cdkDropListDropped)="dropSelected($event)">
      @for (id of selectedColumns; track id) {
        <div class="column mat-elevation-z1" [ngClass]="{ 'accent-background-100': initialColumns.indexOf(id) === -1, 'primary-background-100': initialColumns.indexOf(id) !== -1 }" cdkDrag (click)="unselectColumn(id)">{{ captions[id] }}</div>
      }
    </div>
  </div>
  <div id="available-columns" class="flex-50">
    <div class="caption">Available Columns</div>
    <div cdkDropList [cdkDropListData]="availableColumns" class="list-container" (cdkDropListDropped)="dropAvailable($event)">
      @for (id of availableColumns; track id) {
        <div class="column mat-elevation-z1" [ngClass]="{ 'accent-background-100': initialColumns.indexOf(id) === -1, 'primary-background-100': initialColumns.indexOf(id) !== -1 }" cdkDrag (click)="selectColumn(id)">{{ captions[id] }}</div>
      }
    </div>
  </div>
</div>
<div class="buttons">
  <button mat-button (click)="close()" i18n>CLOSE</button>
  <button mat-button (click)="save()" i18n>SAVE</button>
</div>
